/* ============================================================
   Priority finding card.

   The severity chip is coloured by SEVERITY, not by domain. Using the
   domain's categorical colour meant the weakest finding could render in
   green simply because "Fleet & transport" is green in the chart
   palette — the opposite of the signal intended. Categorical colours
   distinguish series; they must never encode good or bad.

   Audit A-23: color-mix() has a flat token fallback beneath it so older
   Android WebViews get a visible surface rather than none.
   ============================================================ */

import { html } from '../shared/html.js';
import { readable } from '../shared/tone.js';

function severityFor(percentage) {
  if (percentage < 45) return { color: 'var(--ca-danger)', label: 'Critical' };
  if (percentage < 65) return { color: 'var(--ca-warning)', label: 'Needs work' };
  return { color: 'var(--ca-positive)', label: 'Solid' };
}

export function FindingCard({ rank, domainName, percentage, weight, color, recommendation }) {
  const severity = severityFor(percentage);

  const card = document.createElement('div');
  card.className = 'finding-card avoid-break';

  card.innerHTML = html`
    <div class="row" style="gap: var(--ca-space-2); margin-bottom: var(--ca-space-2);">
      <span
        class="finding-sev"
        style="margin-bottom: 0; background: var(--ca-surface-sunk);
               background: color-mix(in srgb, ${severity.color} 13%, transparent);
               color: ${readable(severity.color)};"
      >
        #${rank} · ${severity.label}
      </span>
      <span class="row" style="gap: var(--ca-space-2); font-size: var(--ca-text-xs); color: var(--ca-text-tertiary);">
        <span
          aria-hidden="true"
          style="width:8px;height:8px;border-radius:2px;background:${color};display:inline-block;"
        ></span>
        ${domainName}
      </span>
    </div>
    <h4>
      <span class="num">${percentage}%</span> maturity ·
      <span class="num">${weight}%</span> of the index
    </h4>
    <p>${recommendation}</p>
  `;

  return card;
}
